// Shows the outcome of an admin action as a toast; on success re-renders the page.

import type { ApiResult } from "../api/client";
import { t } from "../i18n/i18n";
import { renderCurrentRoute } from "../router";
import { describeProblem, showToast } from "./feedback";
import { describeFieldErrors } from "./forms";

export async function reportAndReload<T>(result: ApiResult<T>): Promise<void> {
  if (result.ok === false) {
    const details: string = describeFieldErrors(result.problem.fieldErrors);
    showToast(details === "" ? describeProblem(result.problem) : `${describeProblem(result.problem)} ${details}`);
    return;
  }

  showToast(t("app.saved"));
  await renderCurrentRoute();
}
